module.exports = __webpack_public_path__ + "img/EntryDonutWarehouse.4110c3af.png";